module.exports = __webpack_public_path__ + "img/package-01.c35d9a5b.png";